import * as fromDataype from '../datatype-library/index';

export interface bl_fi_cfg_ledger_type_RowInterface {
  guid: fromDataype.GuidDataFieldInterface;
  txn_type: fromDataype.VarcharDatatypeInterface;
  name: fromDataype.VarcharDatatypeInterface;
  description: fromDataype.TextDatatypeInterface;
  revision: fromDataype.RevisionDataFieldInterface;
  vrsn: fromDataype.VrsnDataFieldInterface;
}

export class bl_fi_cfg_ledger_type_RowClass
  implements bl_fi_cfg_ledger_type_RowInterface {
  guid: fromDataype.GuidDataFieldInterface;
  txn_type: fromDataype.VarcharDatatypeInterface;
  name: fromDataype.VarcharDatatypeInterface;
  description: fromDataype.TextDatatypeInterface;
  revision: fromDataype.RevisionDataFieldInterface;
  vrsn: fromDataype.VrsnDataFieldInterface;
}
